// constants
import { SELECTORS, FORM_ELEMENTS } from '@/scripts/constants';

// other
import validate from '@/components/Form/validator';

export default class InputBlock {
  constructor(inputBlock) {
    this.element = inputBlock;
    this.type = this.element.dataset.type;
    this.required = this.element.dataset.required;
    this.input = this.type === 'radio' || this.type === 'checkbox'
      ? Array.from(this.element.querySelectorAll(FORM_ELEMENTS.input_block__input))
      : this.element.querySelector(FORM_ELEMENTS.input_block__input);
    this.valid = true;
    this.label = this.element.querySelector(FORM_ELEMENTS.input_block__label);
    this.error = this.element.querySelector(FORM_ELEMENTS.input_block__error);
    this.controller = this.element.dataset.controller || null;

    if (this.type !== 'radio' && this.type !== 'checkbox') {
      this.initAnimation();
    }

    this.activeClass = SELECTORS.active;
    this.invalidClass = SELECTORS.invalid;
  }

  validate() {
    const {
      requiredMessage, validationMessage, required, validation,
    } = this.element.dataset;
    let validationResult = {
      valid: true,
      error: '',
    };
    if ((this.type === 'radio' || this.type === 'checkbox')) {
      validationResult.valid = this.required ? !!this.input.filter(el => el.checked).length : true;
      validationResult.error = validationResult.valid ? '' : requiredMessage;
    } else {
      const field = {
        value: this.input.value,
        name: this.label && this.label.innerText || 'This input',
        required,
        validation,
        validationMessage,
        requiredMessage,
      };

      validationResult = this.input.disabled ? validationResult : validate(field);
    }
    this.valid = validationResult.valid;
    this.element.classList.toggle(this.invalidClass, !this.valid);
    this.error.innerText = validationResult.error.trim();
    this.element.setAttribute('title', validationResult.error);
  }
  addCallback({ event = '', callback = () => {} }) {
    $(this.input).on(event, callback);
  }
  initAnimation() {
    this.element.classList.toggle(this.activeClass, !!this.input.value);
    ['focusin', 'input', 'change', 'focusout'].forEach((event) => {
      this.input.addEventListener(event, (e) => {
        this.element.classList.toggle(
          this.activeClass,
          !!this.input.value
          || e.type !== 'focusout', // keep input in active state if it is focused and has no value
        );
      });
    });
  }

  reset() {
    this.input.value = '';
    this.element.classList.remove(this.activeClass);
  }
}



// WEBPACK FOOTER //
// ./components/Form/components/InputBlock/InputBlock.js